import { Stack } from '@mui/material';
import React, { useState } from 'react';
import ItemCategory from './ItemCategory';

function AllItemsView(props) {
    const [selectedCategory, setSelectedCategory] = useState(null);

    return (
        <Stack spacing={2}>
            { Object.keys(props.review.items).sort((a, b) => a.localeCompare(b)).map((itemCategory) => (
                <ItemCategory 
                    key={itemCategory} 
                    categoryName={itemCategory} 
                    items={props.review.items[itemCategory]} 
                    review={props.review}
                    handleUpdate={props.handleUpdate}
                    isReadOnly={props.isReadOnly}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    variant={props.variant}
                />
            ))}
        </Stack>
    );
}

export default AllItemsView;
